import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import StorageService from '@/services/storage.service';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { languageActions } from '@/stores/action/navigate.action';

import Language from '@/components/global/language/Language';
// import request from '@/services/request.service';
// import request from 'services/request.service'

class LanguageContainer extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            language: {
                selected: props.lang,
                options: [
                    { value: 'en', title: 'EN' },
                    { value: 'ko', title: 'KO' },
                    { value: 'id', title: 'ID' },
                    { value: 'ja', title: 'JP' },
                    { value: 'vi', title: 'VN' },
                    { value: 'zh', title: 'CN' },
                ],
            },
        };
    }

    handleChangeLanguage = (e) => {
        const { LanguageActions } = this.props,
            { value } = e.target;
        LanguageActions.changeLanguage(value).then((lang) => {
            new StorageService().language.set(lang);
            window.location.reload();
        });
    };

    render() {
        const { lang } = this.props,
            { language } = this.state;
        return (
            <Language
                lang={lang}
                langOption={language.options}
                selected={lang}
                onChangeLanguage={this.handleChangeLanguage}
            />
        );
    }
}

export default connect(
    (state) => ({
        lang: state.navigate.getIn(['language', 'selected']),
    }),
    (dispatch) => ({
        LanguageActions: bindActionCreators(languageActions, dispatch),
    }),
)(withRouter(LanguageContainer));
